export const AUCTION_BID_MINIMUM_AMOUNT_IN_PENCE = 5000;
export const AUCTION_MINIMUM_START_BID_AMOUNT_IN_PENCE = 10000;
export const AUCTION_BID_MAX_BIDS_LIMIT = 10000;
